import React from "react";
import styles from "./ConstructionHeader.module.scss";
import ConstructionStatus from "../../../../types/ConstructionStatus";
import type {ConstructionAcceptedIconProps, ConstructionHeaderProps} from "./ConstructionHeaderProps";
import ConstructionNewTagControl from "../tagControl/ConstructionNewTagControl";
import PathConstants from "../../../../routes/pathConstants";
import {format} from "date-fns";
import {Link} from "react-router-dom";
import {Icon} from "@fluentui/react";
import IsaacLanguageSwitcher from "../../../../components/isaacLanguageSwitcher/IsaacLanguageSwitcher";
import ConstructionNavigation from "../navigation/ConstructionNavigation";

const ConstructionHeader: React.FunctionComponent<ConstructionHeaderProps> = ({construction}) => {
  if (construction === null) {
    return null;
  }

  const isConstructionAccepted = construction?.status === ConstructionStatus.Accepted;
  const h2style = isConstructionAccepted ? styles.isAccepted : "";
  return (
    <div className={styles.constructionHeaderContainer}>
      <h2 className={h2style}>{construction?.name}</h2>
      <ConstructionAcceptedIcon isAccepted={isConstructionAccepted} />
      <ConstructionAcceptedLink construction={construction} />
      <ConstructionNewTagControl constructionId={construction.id} tags={construction.tags} />
      <div className={styles.right}>
        <IsaacLanguageSwitcher />
        <ConstructionNavigation />
      </div>
    </div>
  );
};

const ConstructionAcceptedLink: React.FC<ConstructionHeaderProps> = ({construction}) => {
  if (construction === null) {
    return null;
  }
  if (construction.sourceCalculationId === null || construction.sourceModificationTimeStamp === null) {
    return null;
  }

  const linkState = {calculationId: construction?.sourceCalculationId};
  const link = `/${PathConstants.Constructions}/${construction?.id}/${PathConstants.Calculations}/${construction?.sourceCalculationId}`;
  const messageVerb = construction.status === ConstructionStatus.Accepted ? "Accepted" : "Updated";
  const date = new Date(construction.sourceModificationTimeStamp);
  const calculationDateTime = format(date, "dd/MM/yyyy HH:mm");
  const message = ` ${messageVerb} with calculation of ${calculationDateTime}`;

  return (
    <Link state={linkState} to={link}>
      <h3 className={styles.updatedOn}>{message}</h3>
    </Link>
  );
};

const ConstructionAcceptedIcon: React.FC<ConstructionAcceptedIconProps> = ({isAccepted}) => {
  if (!isAccepted) {
    return null;
  }
  const ICON_NAME = "CheckboxCompositeReversed";
  const ICON_TITLE = "Construction is accepted. No changes can be performed.";
  return <Icon iconName={ICON_NAME} className={styles.isAccepted} title={ICON_TITLE} />;
};

export default ConstructionHeader;
